'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: left;\n  '], ['\n    text-align: left;\n  ']);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _reactRedux = require('react-redux');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _H = require('UIComponents/elements/headings/H6');

var _H2 = _interopRequireDefault(_H);

var _colors = require('HubStyleTokens/colors');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITabs = require('UIComponents/nav/UITabs');

var _UITabs2 = _interopRequireDefault(_UITabs);

var _UITab = require('UIComponents/nav/UITab');

var _UITab2 = _interopRequireDefault(_UITab);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogBody = require('UIComponents/dialog/UIDialogBody');

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _reactRouterDom = require('react-router-dom');

var _breakpoint = require('../utils/breakpoint');

var _breakpoint2 = _interopRequireDefault(_breakpoint);

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StickyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Tabs__StickyContainer'
})(['position:sticky;top:0;z-index:100;background:', ';display:flex;justify-content:space-around;box-shadow:0 2px 4px rgba(0,0,0,0.1);'], _colors.OLAF);

var TabDiscountBadge = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'Tabs__TabDiscountBadge'
})(['margin:0;font-weight:bold;font-size:8pt;']);

var DiscountBadgeContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Tabs__DiscountBadgeContainer'
})(['position:absolute;top:-11px;width:100%;']);

var MobileMenuTriggers = (0, _styledComponents2.default)(StickyContainer).withConfig({
  displayName: 'Tabs__MobileMenuTriggers'
})(['display:none;text-align:center;width:100%;cursor:pointer;background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);padding-bottom:0.8em;color:', ';font-size:1.6em;font-weight:100;padding:0.6em 2.4em 0.86em 0.7em;', ' ', ''], _colors.OLAF, _breakpoint2.default.tablet(_templateObject), _breakpoint2.default.phone(_templateObject2));

var MobileMenuCategory = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'Tabs__MobileMenuCategory'
})(['font-weight:800;display:block;position:relative;overflow:hidden;font-size:0.85em;opacity:0.7;margin-top:1.37em;margin-bottom:0.15em;&:first-child{margin-top:0;}&::after{content:\'\';display:inline-block;background-color:', ';height:1px;position:absolute;top:50%;transform:translate(10px,-50%);width:100%;}'], _colors.OLAF);

var MobileMenuBody = (0, _styledComponents2.default)(_UIDialogBody2.default).withConfig({
  displayName: 'Tabs__MobileMenuBody'
})(['background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);&.pricing-mobile-menu-body{padding:3.4em 1.45em;}']);

var MobileMenuLinkWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Tabs__MobileMenuLinkWrapper'
})(['position:relative;display:block;']);

var MobileMenuLink = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'Tabs__MobileMenuLink'
})(['display:inline-block;cursor:pointer;font-size:1.57em;margin:0 0 1em;line-height:1.4;&[selected=\'true\']{text-decoration:underline;}']);

var MobileMenuCloseButton = (0, _styledComponents2.default)(_UIDialogCloseButton2.default).withConfig({
  displayName: 'Tabs__MobileMenuCloseButton'
})(['transform:scale(0.6);right:16px;top:13px;']);

var MobileMenuTriggerLink = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'Tabs__MobileMenuTriggerLink'
})(['display:block;']);

var MobileMenuTriggerCategory = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'Tabs__MobileMenuTriggerCategory'
})(['font-size:0.515em;letter-spacing:0.5px;margin-bottom:0.515em;opacity:0.7;font-weight:600;']);

var MobileMenuTriggerIcon = (0, _styledComponents2.default)(_UIIcon2.default).withConfig({
  displayName: 'Tabs__MobileMenuTriggerIcon'
})(['transform:scale(0.45) translateY(-50%);position:absolute;right:0.06em;margin:0;top:50%;color:', ';'], _colors.OLAF);

var MobileMenuDiscount = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'Tabs__MobileMenuDiscount'
})(['display:inline-block;position:absolute;top:0.4em;background-color:', ';font-size:0.78em;font-weight:500;margin-left:0.9em;padding:0 0.55em;border-radius:3px;line-height:2;'], _colors.OZ);

function Tabs(_ref) {
  var selectedPrimaryTab = _ref.selectedPrimaryTab,
      selectedSecondaryTab = _ref.selectedSecondaryTab,
      history = _ref.history,
      defaultHubRoute = _ref.defaultHubRoute,
      isHSFXEligible = _ref.isHSFXEligible;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var toggleModal = function toggleModal(isVisible) {
    return setModalVisibility(isVisible);
  };

  var navigateTo = function navigateTo(path) {
    history.push(path);
    window.scrollTo(0, 0);
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      MobileMenuTriggers,
      { onClick: (0, _partial2.default)(toggleModal, true) },
      selectedPrimaryTab === 'crm' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.productCategories.freeToolsAndCrm' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.crm.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedSecondaryTab === 'crm' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.pages.products.tabTitle' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.crm.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedSecondaryTab === 'cms' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.pages.products.tabTitle' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.products.tabs.cms.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedSecondaryTab === 'marketing' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.pages.products.tabTitle' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.products.tabs.marketing.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedSecondaryTab === 'sales' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.pages.products.tabTitle' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.products.tabs.sales.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedSecondaryTab === 'service' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.pages.products.tabTitle' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.products.tabs.service.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedPrimaryTab === 'growth-suite' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.productCategories.premiumProducts' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.products.tabs.growthSuite.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      selectedPrimaryTab === 'bundle' && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MobileMenuTriggerCategory, { message: 'pricingPage.productCategories.bundles' }),
        _react2.default.createElement(MobileMenuTriggerLink, {
          message: 'pricingPage.pages.bundle.tabTitle',
          onClick: (0, _partial2.default)(toggleModal, true)
        })
      ),
      _react2.default.createElement(MobileMenuTriggerIcon, { name: 'down', size: 'sm', color: _colors.OLAF })
    ),
    isModalVisible && _react2.default.createElement(
      _UIModal2.default,
      { use: 'success' },
      _react2.default.createElement(MobileMenuCloseButton, {
        onClick: (0, _partial2.default)(toggleModal, false),
        size: 'xl'
      }),
      _react2.default.createElement(
        MobileMenuBody,
        { className: 'pricing-mobile-menu-body' },
        _react2.default.createElement(MobileMenuCategory, {
          message: 'pricingPage.pages.products.tabTitle'
        }),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedSecondaryTab === 'crm',
            message: 'pricingPage.pages.crm.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/crm')
          })
        ),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedSecondaryTab === 'cms',
            message: 'pricingPage.pages.products.tabs.cms.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/cms')
          })
        ),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedSecondaryTab === 'marketing',
            message: 'pricingPage.pages.products.tabs.marketing.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/marketing')
          })
        ),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedSecondaryTab === 'sales',
            message: 'pricingPage.pages.products.tabs.sales.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/sales')
          })
        ),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedSecondaryTab === 'service',
            message: 'pricingPage.pages.products.tabs.service.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/service')
          })
        ),
        _react2.default.createElement(MobileMenuCategory, {
          message: 'pricingPage.productCategories.premiumProducts'
        }),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedSecondaryTab === 'growth-suite',
            message: 'pricingPage.pages.products.tabs.growthSuite.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/growth-suite')
          }),
          !isHSFXEligible && _react2.default.createElement(MobileMenuDiscount, { message: 'pricingPage.pages.growthSuite.percentDiscountBadge' })
        ),
        _react2.default.createElement(MobileMenuCategory, {
          message: 'pricingPage.productCategories.bundles'
        }),
        _react2.default.createElement(
          MobileMenuLinkWrapper,
          null,
          _react2.default.createElement(MobileMenuLink, {
            selected: selectedPrimaryTab === 'bundle',
            message: 'pricingPage.pages.bundle.tabTitle',
            onClick: (0, _partial2.default)(navigateTo, '/bundle')
          })
        )
      )
    ),
    _react2.default.createElement(
      _UITabs2.default,
      {
        selected: selectedPrimaryTab,
        use: 'enclosed',
        wrapperClassName: 'pricing-page-tabs md-hidden'
      },
      _react2.default.createElement(_UITab2.default, {
        tabId: 'products',
        className: 'pricing-page-tab',
        onClick: function onClick() {
          navigateTo(defaultHubRoute);
        },
        title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.products.tabTitle' })
      }),
      _react2.default.createElement(_UITab2.default, {
        tabId: 'growth-suite',
        className: 'pricing-page-tab',
        onClick: (0, _partial2.default)(navigateTo, '/growth-suite'),
        title: _react2.default.createElement(
          'div',
          { style: { position: 'relative' } },
          !isHSFXEligible && _react2.default.createElement(
            DiscountBadgeContainer,
            null,
            _react2.default.createElement(
              TabDiscountBadge,
              null,
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.percentDiscountBadge' })
            )
          ),
          _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.pages.products.tabs.growthSuite.tabTitle'
          })
        )
      }),
      _react2.default.createElement(_UITab2.default, {
        tabId: 'bundle',
        className: 'pricing-page-tab',
        onClick: (0, _partial2.default)(navigateTo, '/bundle'),
        title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.bundle.tabTitle' })
      })
    ),
    selectedSecondaryTab && _react2.default.createElement(
      StickyContainer,
      null,
      _react2.default.createElement(
        _UITabs2.default,
        {
          selected: selectedSecondaryTab,
          wrapperClassName: 'products-page-tabs md-hidden'
        },
        _react2.default.createElement(_UITab2.default, {
          tabId: 'crm',
          className: 'products-page-tab',
          onClick: (0, _partial2.default)(navigateTo, '/crm'),
          title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.tabTitle' })
        }),
        _react2.default.createElement(_UITab2.default, {
          tabId: 'marketing',
          className: 'products-page-tab',
          onClick: (0, _partial2.default)(navigateTo, '/marketing'),
          title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.products.tabs.marketing.tabTitle' })
        }),
        _react2.default.createElement(_UITab2.default, {
          tabId: 'sales',
          className: 'products-page-tab',
          onClick: (0, _partial2.default)(navigateTo, '/sales'),
          title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.products.tabs.sales.tabTitle' })
        }),
        _react2.default.createElement(_UITab2.default, {
          tabId: 'service',
          className: 'products-page-tab',
          onClick: (0, _partial2.default)(navigateTo, '/service'),
          title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.products.tabs.service.tabTitle' })
        }),
        _react2.default.createElement(_UITab2.default, {
          tabId: 'cms',
          className: 'products-page-tab',
          onClick: (0, _partial2.default)(navigateTo, '/cms'),
          title: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.products.tabs.cms.tabTitle' })
        })
      )
    )
  );
}

function mapStateToProps(state) {
  return {
    defaultHubRoute: state.config.defaultHubRoute,
    isHSFXEligible: (0, _PromotionSelectors.isHSFXEligibleSelector)(state)
  };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Tabs));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/Tabs.js
// module id = 656
// module chunks = 3 4